import TagsList from "./TagsList";

export default TagsList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/TagsList/index.tsx